import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './MainStyle.css';
import Home from './components/screens/Home';
import Account from './components/screens/Account';
import ViewProduct from './components/screens/ViewProduct';
import Signin from './components/screens/Signin';
import ChangePassword from './components/screens/ChangePassword';
import MyBag from './components/screens/MyBag';
import Checkout from './components/screens/Checkout';
import Search from './components/screens/Search';
import UpdateProfile from './components/screens/UpdateProfile';
import AddAddress from './components/screens/AddAddress';
import MyOrders from './components/screens/MyOrders';
import MyOrderDetails from './components/screens/MyOrderDetails';
import MyAddress from './components/screens/MyAddress';
import UpdateAddress from './components/screens/UpdateAddress';
import OrderConfirmed from './components/screens/OrderConfirmed';
import Customization from './components/screens/Customization';
import AccountUpdateInfo from './components/screens/AccountUpdateInfo';
import Refund from './components/screens/Refund';
import Onboard from './components/screens/Onboard';
import Verification from './components/screens/Verification';
import Document from './components/screens/Document';
import PageTitleWatcher from './components/other-components/HeadManager/PageTitleWatcher';

function App() {
  return (
    <Router>
      <PageTitleWatcher />

      <Routes>
        <Route path='/home' element={<Home />} />
        <Route path='p/:urlParam' element={<ViewProduct />} />
        <Route path='pages/:urlParam' element={<Document />} />


        <Route path='/signin' element={<Signin />} />
        <Route path='/onboard' element={<Onboard />} />
        <Route path='/verification' element={<Verification />} />
        <Route path='/update-profile' element={<UpdateProfile />} />
        <Route path='/account' element={<Account />} />
        <Route path='/account-update-required' element={<AccountUpdateInfo />} />

        <Route path='/customization' element={<Customization />} />

        <Route path='/myaddress' element={<MyAddress />} />
        <Route path='/add-address' element={<AddAddress />} />
        <Route path='/update-address' element={<UpdateAddress />} />

        <Route path='/myorders' element={<MyOrders />} />
        <Route path='/myorder-details' element={<MyOrderDetails />} />
        <Route path='refund' element={<Refund />} />

        <Route path='/change-password' element={<ChangePassword />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/mybag' element={<MyBag />} />
        <Route path='/order-confirmed' element={<OrderConfirmed />} />

        <Route path="search" element={<Search />} />

        {/* default page */}
        <Route path='/' element={<Home />} />
      </Routes>

    </Router>
  );
}

export default App;
